import { useTables } from "@features/crud-table/hooks/use-tables";
import { ScrollArea } from "@shared/ui/scroll-area";
import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@shared/ui/sidebar";
import { Skeleton } from "@shared/ui/skeleton";
import { Link } from "@tanstack/react-router";
import {
	CreditCard,
	Database,
	FileText,
	Layers,
	List,
	Loader,
	Settings,
	ShoppingBag,
	Table2,
	Users,
} from "lucide-react";
import { FormattedMessage } from "react-intl";

const DEFAULT_ICONS = [Table2, Layers, Database, List];

function getTableIcon(tableName: string) {
	const name = tableName.toLowerCase();

	if (name.includes("user") || name.includes("profile")) return Users;
	if (name.includes("order") || name.includes("product") || name.includes("shop"))
		return ShoppingBag;
	if (name.includes("setting") || name.includes("config")) return Settings;
	if (name.includes("post") || name.includes("log") || name.includes("history")) return FileText;
	if (name.includes("pay") || name.includes("transaction")) return CreditCard;

	const charCodeSum = name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
	return DEFAULT_ICONS[charCodeSum % DEFAULT_ICONS.length];
}

export function NavTables() {
	const { data: tables, isPending: tablesPending } = useTables();

	return (
		<SidebarGroup>
			<SidebarGroupLabel>
				<FormattedMessage id="sidebar.tables.label" defaultMessage="Tables" />
			</SidebarGroupLabel>
			<SidebarGroupContent className="flex flex-col gap-4 pr-0">
				<ScrollArea className="h-[400px] pr-3 -mr-2">
					<SidebarMenu className="space-y-1">
						{tablesPending &&
							[1, 2, 3].map((item) => (
								<SidebarMenuItem key={item}>
									<SidebarMenuButton className="cursor-pointer">
										<Loader className="animate-spin" />
										<Skeleton key={item} className="w-full h-4 rounded-md" />
									</SidebarMenuButton>
								</SidebarMenuItem>
							))}

						{!tablesPending &&
							tables?.map((item) => {
								const TableIcon = getTableIcon(item.table_name);

								return (
									<SidebarMenuItem key={item.table_name}>
										<Link to="/tables/$resource" params={{ resource: item.table_name }}>
											{({ isActive }) => (
												<SidebarMenuButton className="cursor-pointer" isActive={isActive}>
													<TableIcon className="w-4 h-4" />
													<span>{item.table_name}</span>
												</SidebarMenuButton>
											)}
										</Link>
									</SidebarMenuItem>
								);
							})}
					</SidebarMenu>
				</ScrollArea>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
